"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ifOnly = _interopRequireDefault(require("if-only"));

var _Button = _interopRequireDefault(require("../components/Button"));

var _Select = _interopRequireDefault(require("./Select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputGroup = function InputGroup(props) {
  var input = props.input,
      addon = props.addon;

  if (addon.type !== _Button.default && addon.type !== _Select.default) {
    console.warn('Addon type should be either Button or Select');
  }

  return _react.default.createElement("div", {
    className: "InputGroup"
  }, _react.default.createElement("div", {
    className: "InputGroup__inputContainer"
  }, _react.default.cloneElement(input)), _react.default.createElement("div", {
    className: "InputGroup__addonContainer"
  }, addon.type === _Button.default ? _react.default.cloneElement(addon, {
    round: true,
    category: "primary"
  }) : _react.default.cloneElement(addon)));
};

var _default = InputGroup;
exports.default = _default;